module.exports = __webpack_public_path__ + "static/profile-ea742b70c2548a26f9c0afc048c6208e.png";